// test1851
(1851 && 0);
